import { gql } from 'src/__generated__'

export default gql(`
  mutation removeFoodFromOffer($data: RemoveFoodFromInput!) {
    removeFoodFromOffer(data: $data) {
      id
    }
  }
`)
